import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import CreditCardInput from './CreditCardInput';
import ExpirationDateInput from './ExpirationDateInput';
import CvvInput from './CvvInput';
import PostalCodeInput from './PostalCodeInput';
import Disclaimer from '../Disclaimer';

import Button from '../../Button';
import TwoGroup from '../../TwoGroup';
import ButtonGroup from './ButtonGroup';
import FormSectionContainer from './FormSectionContainer';
import SmallFormGroup from './SmallFormGroup';

import { validateCardDetails } from './validations.js';

import styled from 'styled-components';

const AnimatedContainer = styled.div`
    display: flex;
    flex: 1;

    &.transition-enter {
        transform: translate3d(100%, 0, 0);
        z-index: 10;
        background-color: white;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    &.transition-enter.transition-enter-active {
        transition: transform 0.45s;
        transition-timing-function: ease-out;
        transform: translate3d(0, 0, 0);
    }

    &.transition-exit {
        transform: translate3d(0, 0, 0);
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;
        background-color: white;
    }

    &.transition-exit.transition-exit-active {
        transition: transform 0.45s;
        transition-timing-function: ease-in;
        transform: translate3d(100%, 0, 0);
    }
`;

const DisclaimerContainer = styled.div`
    margin-top: 14px;
`;

const MobileStep2Form = props => (
    <AnimatedContainer>
        <FormSectionContainer onSubmit={props.handleSubmit}>
            <SmallFormGroup>
                <CreditCardInput autoFocus={true} />
            </SmallFormGroup>
            <SmallFormGroup>
                <TwoGroup>
                    <ExpirationDateInput />
                    <CvvInput />
                    <PostalCodeInput />
                </TwoGroup>
            </SmallFormGroup>
            <DisclaimerContainer>
                <Disclaimer paymentMethod={props.paymentMethod} />
            </DisclaimerContainer>
            <ButtonGroup>
                <TwoGroup>
                    <Button label="Back" onClick={() => props.mobileGoWizardStep(1)} />
                    <Button
                        primary={true}
                        label={`Give ${props.amountFormated}`}
                        type="submit"
                        disabled={props.invalid || props.submitting}
                    />
                </TwoGroup>
            </ButtonGroup>
        </FormSectionContainer>
    </AnimatedContainer>
);

MobileStep2Form.propTypes = {
    onBackToAmount: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    mobileGoWizardStep: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    amountFormated: PropTypes.string.isRequired,
    partnerLogo: PropTypes.string.isRequired,
    paymentMethod: PropTypes.string.isRequired
};

export default compose(
    connect(state => ({
        initialValues: {
            postalCode: state.cachedFormData.postalCode || ''
        }
    })),
    reduxForm({
        form: 'donationDetailsFormStep2',
        destroyOnUnmount: false,
        validate: validateCardDetails
    })
)(MobileStep2Form);



// WEBPACK FOOTER //
// ./src/components/Donation/Form/MobileStep2Form.jsx